import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST, genURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { parseJwt } from "../parseJWT";
import PopupArcode from './../PopUp/PopUpArcode';
import PopUpOther from './../PopUp/PopUpOther';
import PopUpOther3 from '../PopUp/PopUpARInvDebt';
import PopUpcsvarinvbalpay from '../PopUp/PopUpCsvarinvbalpay';
import PopUpprereceipt from '../PopUp/PopUpPrereceipt';
import PopUpOther4 from '../PopUp/PopUpARPaybill';
import PopUpSearchDoc, { ReDate } from './../PopUp/PopUpSearchDoc';
import PopUpSaveMoney from './../PopUp/PopUpSaveMoney';
import PopUpReport from "../PopUp/_fromShow";
import Checkdocgroup from './../CustomFunction/Docgroup/Checkdocgroup'
import Chackdocno from './../CustomFunction/Docno/GetDocno'
import ChackAr from './../CustomFunction/Csar/GetAr'
import CheckBrabchname from './../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../CustomFunction/Department/Checkname'
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Grid, Col } from "react-bootstrap";
import FullScreenDialogs from '../PopUp/FullScreendialogs/FullScreen'
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
import Topbar from "../Components/Customtopbar/Topbar";
import PopUpMultipletax from './../PopUp/PopUpMultipletax'
import FullScreenDialog from './../PopUp/FullScreendialogs/FullScreen'
import SelectDatas from "./../PopUp/SelectData"
import FullScreenDialognew from "../Components/CustomDialogs/Fullscreendialog";

import Receiptwithholding from "../PopUp/Receiptwithholding/Receiptwithholding";
import Rechecked from "./Components/Rechecked";
import Repostview from "../Components/Reportview/Repostview";

const listmenu = [
    ["เลือกเอกสารตั้งหนี้คงค้าง", "ARInvDebt"],
    ["เลือกเอกสาตั้งหนี้และใบวางบิล", "csvarinvbalpay"],
    ["เลือกใบวางบิล", "ARPaybill"],
    ["บันทึกใบกำกับภาษีหลายใบ", "Inputmultipletax"],
    ["ภาษีถูกหัก ณ ที่จ่าย", "Receiptwithholding"],
    ["บันทึกรับเงิน", "save"],
]
export default class Index extends React.Component {
    customStyle = () => {
        return {
            backgroundColor: '#f2f2f2'
        };
    }
    constructor(props) {
        super(props);
        this.CustomerCode = React.createRef();
        this.CustomerName = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.Currencycode = React.createRef();
        this.exchangerate = React.createRef("1.0000000");
        this.Department_code = React.createRef();
        this.Department = React.createRef();
        this.Branch_code = React.createRef();
        this.Branch = React.createRef();
        this.Sumpayamount = React.createRef();
        this.bathpayamount1 = React.createRef();
        this.bathpayamount2 = React.createRef();
        this.Discamount = React.createRef();
        this.bathprofit = React.createRef();
        this.bathloss = React.createRef();
        this.Depositpayment = React.createRef();
        this.Remark = React.createRef();
        this.Netpayamount = React.createRef();
        this.state = {
            Save_status: false,
            openFullScreenDialogs: false,
            SwitchPopupArcode: false,
            showPopupOT3: false,
            showPopupOT4: false,
            tableData: [],
            selectRow: [],
            DocType: [],
            SGstatus: true,
            DisInput: true,
            mstremark: '-',
            tfdocPrint: "",
            CHLOOP: 0,
            loading: "none",
            Currencycode: "บาท",
            Expcode: "",
            rowtb: "300",
            Branch_txt: "",
            Department_txt: "",
            Department_code: "",
            Groupdata_txt: "",
            CSdelete: "far fa-trash-alt",
            CSdeletes: false,
            CSdelete_yes: false,
            AmountPayable: 0,
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            show1: false,
            ddd: "",
            Namedelete: "",
            dataMultipletax: "",
            setMultipletax: "",
            Docdate1: "",
            Groupcode: "",
            Groupname: "",
            Docno: "",
            Remark: "",
            CashReceipt: "",
            BOOKNO: "",
            BANKAMOUNT: "",
            BANKEXPEND: "",
            BOOKDESC: "",
            Remakcase: "",
            Expenses: "",
            Expensessum: "",
            checkenableInput: [],
            PROJECT: "",
            reporturl: "",
            formPrintdata: "",
            resrecheckeddata: []

        }
    }

    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date = myDate.getDate();
            if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1);
            if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    ///-------------------------------------save data ----------------------------------------------
    _connectsaveData = async () => {
        // console.log(this.state.creditType);
        // -----------------------------------------------
        //  this.saveData();
    }
    _get_PopUpSaveMoney = async (sstatus, data1, data2, data3, Bill, Billsum, Credit, Creditsum, Income, Incomesum, Expenses, Expensessum, CHARGEAMOUNT, CHARGEPAY1, CHARGEPAY2, tbBill, tbCredit, tbotherincome, tbexpenses,
        //เพิ่มเติม
        arrayCchq,
        arrayCredit,
        arrayexpenses,
        arrayotherincome
    ) => {
        console.log("sssarrayCchq", arrayCchq);
        console.log("sssarrayCredit", arrayCredit);
        console.log("sssarrayexpenses", arrayexpenses);
        console.log("sssarrayotherincome", arrayotherincome);

        var split_data2 = data3.split("|");
        await this.setState({
            CashReceipt: data2, //เงินสด
            BOOKNO: split_data2[0], //เลขบัญชี
            BANKAMOUNT: split_data2[1],//ยอดเงินโอน
            BANKEXPEND: split_data2[2],//ค่าธรรมเนียมจ่ายหักบัญชี
            BOOKDESC: split_data2[3] === "" ? "" : typeof split_data2[3] !== undefined ? split_data2[3] : "",
            Remakcase: split_data2[3] === "" ? "" : split_data2[3],
            Bill: Bill,
            Billsum: Billsum,
            Credit: Credit,
            Creditsum: Creditsum,
            Income: Income,
            Incomesum: Incomesum,
            Expenses: Expenses,
            Expensessum: Expensessum,
            arrayCchq: arrayCchq,
            arrayCredit: arrayCredit,
            arrayexpenses: arrayexpenses,
            arrayotherincome: arrayotherincome
        })

        if (split_data2[1] > 0 && (split_data2[0] === '0' || split_data2[0] === '')) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ยอดการรับเงินโอนไม่ถูกต้องกรุณาตรวจสอบข้อมูลอีกครั้ง" })
            return
        }
        this.saveData()

        // this.saveData(CashReceipt, BOOKNO, BANKAMOUNT, BANKEXPEND, BOOKDESC, Remakcase, Expenses, Expensessum);
    }
    ResetThisPage = (type) => {
        if (type === "NEW") {
            if (this.state.iconNoWash) {
                this.onAddValue("Groupdata", "PR");
            } else {
                this.componentDidMount();
            }
        } else if (type === "SAVE") {
            window.location.replace("/PSReceipt");
        }
    }
    async componentDidMount() {
        //เช็คเปิดปิด textbox 
        await this.setState({
            checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
        })

        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        // this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
        this.setRow(this.state.rowtb);
        // this.Get_UserCode(localStorage.getItem("Username"));
        this.onAddValue("Branch", SITECODESTR.User.SITECODE);
        this.exchangerate.current.value = "1.0000000"

        let mid = new URLSearchParams(location.search).get("mid")
        this.loadFromindb(mid)
    }

    loadFromindb = async (mid) => { //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
        console.log("res.data", mid)
        let url = `reportmanage/reportform/${mid}?`

        let res = await axios.get(genURL(url))
        console.log("ressssss", res.data)
        if (res.data.length > 0) {
            await this.setState({ reporturl: res.data[0].pathname })
            await this.setState({ formPrintdata: res.data })
        }
    }


    setRow = (count) => {
        var data = [];
        for (var i = 0; i < count; i++) {
            data[i] = {
                li: i + 1
            }
        }
        this.setState({ tableData: data });
        // this.setState({ CSdelete: "" });
    }
    deleterow = (id) => {
        var Old_HTML = ""
        if (document.getElementById(id)) {
            Old_HTML = document.getElementById(id).innerHTML;
            document.getElementById(id).innerHTML = '<i className="far fa-minus-square"></i>';
        }
    }
    Get_Arcode = (event) => {
        if (this.CustomerCode.current.value === "") {
            this.CustomerName.current.value = "";
        }
        if (event.key === "Enter" && event.target.value !== "") {
            this.setState({ openBackdrop: true })
            var arcode = (event.target.value).trim();
            var url = "CSAR/ARCode?arcode=" + arcode + "&user=" + localStorage.getItem("Username");
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.length > 0) {
                    this.CustomerCode.current.value = res.data[0].CODE;
                    this.CustomerName.current.value = res.data[0].NAMETH;
                    this.setState({ openBackdrop: false })
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    this.CustomerCode.current.value = "";
                    this.CustomerName.current.value = "";
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                this.setState({ openBackdrop: false })
            });
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
    }
    _calprice = (e) => {
        var Sumpayamount = 0.00;
        var _sumamountC5 = 0.00;
        for (var i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].T_Payment && this.state.tableData[i].T_Category_Code === "0") {
                Sumpayamount += parseFloat(this.state.tableData[i].T_Payment)
            } else if (this.state.tableData[i].T_Payment && this.state.tableData[i].T_Category_Code === "1") {
                Sumpayamount -= parseFloat(this.state.tableData[i].T_Payment)
            } else if (this.state.tableData[i].T_Payment) {
                Sumpayamount += parseFloat(this.state.tableData[i].T_Payment)
            }
            if (this.state.tableData[i].T_Residual) {
                _sumamountC5 += parseFloat(this.state.tableData[i].T_Residual)
            }
        }
        setTimeout(() => {
            this.setState({ _sumamountC5_s: _sumamountC5 })
        }, 30);
        this.bathpayamount1.current.value = Sumpayamount.toFixed(2);
        this.bathpayamount2.current.value = Sumpayamount.toFixed(2);
        this.Sumpayamount.current.value = Sumpayamount.toFixed(2);
        this.Netpayamount.current.value = parseFloat((Sumpayamount - this.Depositpayment.current.value) - this.Discamount.current.value).toFixed(2);
        var Discamount = 0;
        if (this.Discamount.current.value) { Discamount = parseFloat(this.Discamount.current.value).toFixed(2); }
        this.Discamount.current.value = parseFloat(Discamount).toFixed(2);
        var Depositpayment = 0;
        if (this.Depositpayment.current.value) { Depositpayment = parseFloat(this.Depositpayment.current.value).toFixed(2); }
        this.Depositpayment.current.value = parseFloat(Depositpayment).toFixed(2);
        var Netpayamount = 0;
        if (this.Netpayamount.current.value) {
            Netpayamount = parseFloat(this.Netpayamount.current.value).toFixed(2);
        }
        /* this.Netpayamount.current.value = parseFloat(Netpayamount).toFixed(2); */
        this.setState({ AmountPayable: this.Netpayamount.current.value });
    }
    Cal_Price1 = (e) => {
        if (e.key === "Enter" && e.target.value !== "") {
            this._calprice();
        }
    }
    Get_UserCode = (data) => {
        this.setState({ UserCode_code: localStorage.getItem("Username") });
        this.setState({ UserCode_txt: localStorage.getItem('UsernameTH') });
        this.setState({ UserCode: localStorage.getItem('UsernameTH') });
    }
    SelectSetData = (type, data) => {
        var pdata = data.split("|");
        switch (type) {
            case "Taxtype":
                this.setState({ Taxtype: pdata[1] })
                this.setState({ CTaxtype: pdata[0] });
                break;
            case "Calendar1":
                this.setState({ Docdate: data });
                break;
            case "PROJECT":
                this.setState({ PROJECT: data })
                break;
            default: break
        }
    }
    onKeyPress = (e) => {
        var value = e.target.value;
        if (e.key === 'Enter') {
            if (e.target.name === 'Groupdata') {
                this.setState({ openBackdrop: true })
                var url = "CSDOCGROUP/Code?tablename=CSRECEIPT&code=" + e.target.value;
                console.log(genURL(url));
                axios.get(genURL(url), { timeout: 3600 }).then(res => {
                    if (res.data.length > 0) {
                        this.setState({ Groupdata_txt: res.data[0].MYNAMETH });
                        this.setState({ DOCGROUP_code: res.data[0].CODE });
                        this.Groupdata.current.value = res.data[0].MYNAMETH;
                        this.setState({ RUNGROUP_code: res.data[0].RUNGROUP });
                        this.onClickDocNo(res.data[0].CODE)
                        this.setState({ openBackdrop: false })
                    } else {
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "ไม่พบข้อมูล" })
                        this.setState({ Groupdata_txt: "" });
                        this.setState({ DOCGROUP_code: "" });
                        this.Groupdata.current.value = "";
                        this.DeliNumber.current.value = "";
                        this.setState({ openBackdrop: false })
                    }
                }).catch(error => {
                    console.log(error);
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                    this.setState({ openBackdrop: false })
                });
            }
            if (e.target.name === 'Department') {
                this._getdepartment(e.target.value)
            }
            if (e.target.name === 'Branch') {
                this._getSite(value)
            }
        }
    }
    _getdepartment = async (code) => {
        this.setState({ openBackdrop: true })
        var url = "CSDEPARTMENT/ByCode?code=" + code + "&user=" + localStorage.getItem("Username");
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data.length > 0) {
                this.setState({ Department_txt: res.data[0].MYNAMETH });
                this.setState({ Department_code: res.data[0].CODE });
                this.Department.current.value = res.data[0].MYNAMETH;
                this.setState({ openBackdrop: false })
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบข้อมูล" })
                this.setState({ Department_txt: "" });
                this.setState({ Department_code: "" });
                this.Department.current.value = "";
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
            this.setState({ openBackdrop: false })
        });
    }
    _getSite = async (code) => {
        this.setState({ openBackdrop: true })
        var url = "CSSITE/Getsite?Code=" + code + "&user=" + localStorage.getItem("Username");
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data.length > 0) {
                this.setState({ Branch_txt: res.data[0].MYNAMETH });
                this.setState({ SiteCode_code: res.data[0].CODE });
                this.Branch.current.value = res.data[0].MYNAMETH;
                this.setState({ openBackdrop: false })
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบข้อมูล" })
                this.setState({ Branch_txt: "" });
                this.setState({ SiteCode_code: "" });
                this.Branch.current.value = "";
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
            this.setState({ openBackdrop: false })
        });
    }
    SetPopup = (e) => {
        this.setState({ OtPopupType: e })
        // this.setState({ showPopupOT: !this.state.showPopupOT });
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        if (e === "Groupdata") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" })
        }
        if (e === "Department") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" })
        }
        if (e === "Branch") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" })
        }
    }
    Switch_PopupArcode = (e) => {
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" })
    }
    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type })
        this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    }
    Switch_PopUpSaveMoney = (e) => {
        this.setState({ PopUpSaveMoney: false });
    }

    Get_PopUparcode = (data1, data2) => {
        this.CloseDialog(false)
        this.CustomerCode.current.value = data1.trim();
        this.CustomerName.current.value = data2;
    }
    Get_PopUpOther = async (val) => {
        this.CloseDialog(false)
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.OtPopupType) {
            case "Groupdata":
                this.Groupdata_code.current.value = data[0]
                this.Groupdata.current.value = data[1]
                this.setState({ Groupdata_txt: data[1] });
                await Chackdocno(data[0], "CSRECEIPT").then(async (result1) => {
                    if (result1 !== undefined) {
                        this.DeliNumber.current.value = await result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            case "Department":
                this.Department_code.current.value = await data[0];
                this.Department.current.value = await data[1];
                this.setState({ Department_txt: data[1] });
                break;
            case "Branch":
                this.Branch_code.current.value = await data[0];
                this.Branch.current.value = await data[1];
                this.setState({ Branch_txt: data[1] });
                break;
            default:
                break;
        }
    };
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    onClickDocNo = (code) => {
        if (code) {
            var url = "CSDOCGROUP/Code?tablename=CSRECEIPT&code=" + code;
            console.log(genURL(url));
            axios.get(genURL(url)).then(res1 => {
                console.log(res1);
                if (res1.data.length > 0) {
                    var Url1 = "CSMAXDOC/MAXDOC?tablename=CSRECEIPT&code=" + res1.data[0].CODE;
                    console.log(genURL(Url1));
                    axios.get(genURL(Url1)).then(res => {
                        if (res !== "error") {
                            this.DeliNumber.current.value = res.data["maxdoc"];
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            return
                        }
                    });
                }
            });
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            this.DeliNumber.current.value = "";
        }
    }
    onRowClick = (row, col, id) => {
        let T_Payment = row.T_Payment // จำนวนเต็มเวลาคลิก
        if (col === 6 && T_Payment !== "" && T_Payment !== undefined) {
            row.T_Payment = parseFloat(T_Payment).toFixed(0)
        }
    }
    ReLoadData = () => {
        var col = this.state.tableData
        var NewCol = [], j = 0
        for (var i = 0; i < col.length; i++) {
            if (col[i].T_Docdebt) {
                NewCol[j] = col[i]
                NewCol[j].C0 = j
                j++
            }
        }
        for (var i = j; i < col.length; i++) {
            NewCol[j] = { li: j + 1, C0: j, SB: "0" }
            j++
        }
        this.setState({ tableData: NewCol })
    }
    afterSaveCell = (row, cellName, cellValue) => {
        var data = this.state.tableData;
        if (row.T_Docdebt === "" || row.T_Docdebt === undefined) {
            this.ReLoadData()
        }
        if (cellName === "T_Payment") {
            var _c5 = Number(row.T_Residual)
            var _c6 = Number(row.T_Payment)
            var sum = _c5 - _c6
            console.log(_c6, sum);
            if (_c5 >= _c6) {
                row.T_Payment = parseFloat(_c6).toFixed(2)
                row.T_Overdue = parseFloat(sum).toFixed(2)
            } else if (_c6 > _c5) {
                row.T_Overdue = parseFloat(0).toFixed(2)
                row.T_Payment = _c5
            }
            ///--------------------------------------- คำนวณเงินใหม่ -------------------------------------------------------------- 
            setTimeout(() => {
                this._calprice()
            }, 30);
        }
    }
    SetRowNull = (RowId) => {
        var data = this.state.tableData;
        for (var i = 0; i <= this.state.rowtb - 1; i++) {
            if (i === RowId) {
                data[RowId] = {
                    li: i + 1,
                    T_Docdebt: "",
                    T_Taxinvoice: "",
                    T_Datedebt: "",
                    T_Duedate: "",
                    T_Residual: "",
                    T_Payment: "",
                    T_Overdue: "",
                    T_Remark: "",
                    T_Category: "",
                    T_Paybill: "",
                    SELFLAG: "",
                    SELFLAG2: "",
                    usercode: "",
                    project: "",
                    allocatecode: "",
                    sitecode: "",
                    REFTAXAMOUNT: "",
                    PAYTAXAMOUNT: "",
                    INTEREST_RATE: "",
                    PAYINTEREST: "",
                    ARCODE: "",
                    ARNAME: "",
                    DOCGROUP: "",
                    PAYBILLAMOUNT: "",
                    PREPAYAMOUNT: "",
                    FACTORING: "",
                    REFAMOUNT: "",
                    DEPARTNAME: "",
                    BILLEXCHANGERATE: "",
                    CURRENCYCODE: "",
                    CURRNAME: "",
                    TRANSREFDOCNO: "",
                    REFINTEREST: ""
                }
            }
        }
        this.setState({ tableData: data });
    }
    int_format = (int) => {
        var re = 0;
        if (int) {
            re = parseFloat(int).toFixed(2);
        } else {
            re = parseFloat(re).toFixed(2);
        }
        return re;
    }
    AddDataRow = () => {
        var allrowTable = this.state.rowtb - 1;
        var data = this.state.tableData;
        var j = 0;
        for (var i = 0; i <= allrowTable; i++) {
            if (data[i].T_Docdebt !== "") {
                data[j] = {
                    li: j + 1,
                    C0: j,
                    T_Docdebt: data[i].T_Docdebt,
                    T_Taxinvoice: data[i].T_Taxinvoice,
                    T_Datedebt: data[i].T_Datedebt,
                    T_Duedate: data[i].T_Duedate,
                    T_Residual: parseFloat(data[i].T_Residual).toFixed(2),
                    T_Payment: parseFloat(data[i].T_Payment).toFixed(2),
                    T_Overdue: parseFloat(data[i].T_Residual - data[i].T_Payment).toFixed(2),
                    T_Remark: data[i].T_Remark,
                    T_Category: data[i].T_Category,
                    T_Paybill: data[i].T_Paybill,
                    // SB: "1",
                }
                j++;
            }
        }
        this.DeletRow(j, allrowTable);
        this._calprice();
    }
    DeletRow = (str, end) => {
        var data = this.state.tableData;
        for (var i = str; i <= end; i++) {
            data[i] = {
                li: i + 1,
                C0: i,
                T_Docdebt: "",
                T_Duedate: "",
                SB: "0"
            }
        }
        this.setState({ tableData: data });
    }
    Getformatdatetime = (date) => {
        if (date) {
            var year = date.substring(6, 10);
            var month = date.substring(3, 5);
            var day = date.substring(0, 2);
            if (year > 2500) {
                year = year - 543;
            }
            return year + month + day;
        } else {
            return "";
        }
    }
    // saveData = (CashReceipt, BOOKNO, BANKAMOUNT, BANKEXPEND, remarkcashreceipt, data3, data4, _orterExpenses) => {
    saveData = async () => {
        const parameter = new URLSearchParams();
        var dataTT = [];
        var s = [];
        for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) {
            if (this.state.tableData[i].T_Docdebt !== "") {
                dataTT[i] = {
                    T_Docdebt: this.state.tableData[i].T_Docdebt,
                    T_Taxinvoice: this.state.tableData[i].T_Taxinvoice,
                    T_Datedebt: this.state.tableData[i].T_Datedebt,
                    T_Duedate: this.state.tableData[i].T_Duedate,
                    T_Residual: this.state.tableData[i].T_Residual,
                    T_Payment: this.state.tableData[i].T_Payment,
                    T_Overdue: parseFloat(this.state.tableData[i].T_Overdue).toFixed(0),
                    T_Remark: this.state.tableData[i].T_Remark,
                    T_Category_Code: this.state.tableData[i].T_Category_Code,
                    T_Paybill: this.state.tableData[i].T_Paybill
                }
                s.push(dataTT[i])
            }
        }
        // console.log("listitem", s)
        console.log("listitem", JSON.stringify(s))
        parameter.append("listitem", JSON.stringify(s));
        parameter.append("withholdingData", JSON.stringify(typeof this.state.withholdingData !== 'undefined' ? this.state.withholdingData : []));
        // console.log("data3" + data3)
        var row = this.state.setMultipletax
        console.log(row);
        var Multipletaxdata = []
        var Multipletaxdatanew = []
        var BEFORETAX = 0
        var TAXAMOUNT = 0
        for (let i = 0; i < row.length; i++) {
            if (row[i].Taxno) {
                BEFORETAX += Number(row[i].Beforetax)
                TAXAMOUNT += Number(row[i].Taxamount)
                Multipletaxdatanew[i] = {
                    Arcode: row[i].Arcode,
                    Arname: row[i].Arname,
                    Beforetax: row[i].Beforetax,
                    Code: row[i].Code,
                    Remark: row[i].Remark,
                    Taxamount: row[i].Taxamount,
                    Taxdate: row[i].Taxdate,
                    Taxno: row[i].Taxno,
                    Totalamount: row[i].Totalamount,
                    Zerotax: row[i].Zerotax
                }
                Multipletaxdata.push(Multipletaxdatanew[i]);
            }
        }

        parameter.append("Multipletax", JSON.stringify(Multipletaxdata));
        parameter.append("BEFORETAX", BEFORETAX);
        parameter.append("TAXAMOUNT", TAXAMOUNT);
        parameter.append("TAXAMOUNT2", TAXAMOUNT);

        let Billsum = this.state.Billsum, Credit = this.state.Credit,
            Creditsum = this.state.Creditsum, Income = this.state.Income, Incomesum = this.state.Incomesum
        parameter.append("CSRECCHQ", JSON.stringify(this.state.arrayCchq));
        // parameter.append("CHEQUEAMOUNT", !Billsum ? 0 : Billsum);
        parameter.append("CSRECCREDIT", JSON.stringify(this.state.arrayCredit))
        // parameter.append("CREDITAMOUNT", !Creditsum ? 0 : Creditsum);
        parameter.append("CSRECINCOME", JSON.stringify(this.state.arrayotherincome));
        // parameter.append("INCOMEAMOUNT", !Incomesum ? 0 : Incomesum);

        parameter.append("otherexpenseslist", JSON.stringify(this.state.arrayexpenses))
        parameter.append("ARCODE", this.CustomerCode.current.value);
        parameter.append("ARNAME", this.CustomerName.current.value);
        // parameter.append("DOCDATE", GDocdate);
        parameter.append("DOCDATE", this.state.Docdate);
        parameter.append("DOCGROUP", this.Groupdata_code.current.value);
        parameter.append("DOCNO", this.DeliNumber.current.value);
        parameter.append("REMARK", this.Remark.current.value);
        parameter.append("DEPARTMENT", this.Department_code.current.value);
        parameter.append("SITECODE", this.Branch_code.current.value);
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("SUMPAYAMOUNT", this.Sumpayamount.current.value);
        parameter.append("DISCAMOUNT", this.Discamount.current.value);
        parameter.append("DEPOSITPAYMENT", this.Depositpayment.current.value);
        parameter.append("NETPAYAMOUNT", this.Netpayamount.current.value);
        parameter.append("CASHAMOUNT", this.state.CashReceipt);
        parameter.append("EXPENDAMOUNT", this.state.Expensessum);
        parameter.append("BOOKNO", this.state.BOOKNO);
        parameter.append("BANKAMOUNT", this.state.BANKAMOUNT);
        parameter.append("BANKEXPEND", this.state.BANKEXPEND);
        parameter.append("EXCHANGERATE", this.exchangerate.current.value);
        parameter.append("BATHDISCAMOUNT", this.Discamount.current.value);
        parameter.append("BATHPAYAMOUNT1", this.bathpayamount1.current.value);
        parameter.append("BATHPAYAMOUNT2", this.bathpayamount2.current.value);

        parameter.append("Remakcase", typeof this.state.Remakcase === undefined ? "" : this.state.Remakcase);
        // parameter.append("BOOKDESC", remarkcashreceipt)
        parameter.append("BOOKDESC", this.state.BOOKDESC)
        parameter.append("sumallmoney", this.state._sumamountC5_s)
        parameter.append("PROJECT", this.state.PROJECT)
        // parameter.append("EXPENDAMOUNT", _orterExpenses)

        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair[0], "==", pair[1]);
            if (pair[1] === "" && pair[0] === "DOCNO") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล...!" })
                return
            }
            if (pair[1] === "" && pair[0] === "DEPARTMENT") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกแผนก...!" })
                return
            }
            if (pair[1] === "" && pair[0] === "listitem") {
                Uststus = false;
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเพิ่มรายการรับชำระ...!" })
                return
            }
        }

        if (Uststus === true) {
            // this.setState({ openBackdrop: true })
            //this._printReport('MTRB02-670502-020')

            await axios.post(genpostURL("CSRECEIPT/Save?"), parameter).then(async res => {
                // console.log("resxxxxxxxxxxx Uststus", Uststus);
                // await axios.post(genpostURLTEST("/Save?"), parameter).then(res => {
                if (res.data.status === "success") {
                    await this.setState({ opensnackbar: true })
                    await this.setState({ color: "success" })
                    await this.setState({ icon: ErrorIcon })
                    await this.setState({ messagealert: "บันทึกสำเร็จ" })

                    await this.setState({ openBackdrop: false })
                    await this._printReport(res.data.docno)

                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกไม่สำเร็จ " + res.data.status })
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                this.setState({ openBackdrop: false })
            });
        }
    }
    chkdata = (data) => {
        var redata = "";
        if (data !== "null") {
            redata = data;
        }
        return redata;
    }
    //--------------------------------popup3
    SetPopup3 = (data) => {
        if (this.CustomerCode.current.value) {
            this.setState({ PopUpTYpe3: data });
            //ชื่อ
            this.setState({ typeFullScreenDialog: data })
            //open
            this.setState({ openFullScreenDialog: true })
            //title
            this.setState({ titleFullScreenDialog: "เลือกเอกสารตั้งลูกหนี้คงค้าง-ArInvDebt" })
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาใส่! รหัสลูกหนี้" })
        }
    }
    SetPopUpcsvarinvbalpay = (e) => {
        if (this.CustomerCode.current.value) {
            // this.setState({ showPopUpcsvarinvbalpay: !this.state.showPopUpcsvarinvbalpay });
            //ชื่อ
            this.setState({ typeFullScreenDialog: e })
            //open
            this.setState({ openFullScreenDialog: true })
            //title
            this.setState({ titleFullScreenDialog: "เลือกเอกสาตั้งหนี้และใบวางบิล-ArInvDebtPAYBILL" })
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาใส่! รหัสลูกหนี้" })
        }
    }
    REFDOCTYPE_TXT = (data) => {
        switch (data) {
            case "0":
                return "บิลขายเชื่อ"
                break;
            case "1":
                return "ลดหนี้การค้า"
                break;
            case "2":
                return ""
                break;
            case "3":
                return "ตั้งหนี้อื่นๆ"
                break;
            case "4":
                return "ลดหนี้อื่นๆ"
                break;
            case "5":
                return "ตั้งหนี้ยกมา"
                break;
        }
    }
    Get_PopUpOther3 = (data) => {
        this.CloseDialog(false)
        this.setdelete_no();
        var split_data = data.split("|");
        console.log(split_data);
        switch (this.state.PopUpTYpe3) {
            case "ARInvDebt":
                var element = true
                for (let index = 0; index < this.state.tableData.length; index++) {
                    let arrData = this.state.tableData;
                    if (arrData[index].T_Docdebt !== "" && arrData[index].T_Taxinvoice === split_data[1]) {
                        element = false
                        this.onAddValue("Department", this.chkdata(split_data[6]));
                        this.onAddValue("Branch", this.chkdata(split_data[16]));
                    }
                }
                for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) { }
                if (i > this.state.rowtb - 1) {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "รายการข้อมูลเกินกำหนด" })
                    return;
                }
                console.log(element);
                if (element === true) {
                    let arrData = this.state.tableData;
                    var vc5 = split_data[8];
                    var vc6 = split_data[8];
                    arrData[i].T_Docdebt = this.chkdata(split_data[0]);
                    arrData[i].T_Taxinvoice = this.chkdata(split_data[1]);
                    arrData[i].T_Datedebt = this.chkdata(split_data[2]);
                    arrData[i].T_Duedate = this.chkdata(split_data[4]);
                    arrData[i].T_Residual = this.chkdata(parseFloat(vc5).toFixed(2));
                    arrData[i].T_Payment = this.chkdata(parseFloat(vc6).toFixed(2));
                    arrData[i].T_Overdue = this.chkdata(parseFloat(vc5 - vc6).toFixed(2));
                    arrData[i].T_Remark = this.chkdata(split_data[9]);
                    arrData[i].T_Category = this.REFDOCTYPE_TXT(split_data[10]);
                    arrData[i].T_Category_Code = split_data[10];
                    arrData[i].T_Paybill = "";
                    arrData[i].SELFLAG = this.chkdata(split_data[11]);
                    arrData[i].SELFLAG2 = this.chkdata(split_data[12]);
                    arrData[i].usercode = this.chkdata(split_data[13]);
                    arrData[i].SB = '1'
                    this.setState({ tableData: arrData });
                    this.bathprofit.current.value = "0.00"
                    this.bathloss.current.value = "0.00"
                    this._calprice();
                    setTimeout(() => {
                        this.onAddValue("Department", this.chkdata(split_data[6]));
                        this.onAddValue("Branch", this.chkdata(split_data[16]));
                        // this._getdepartment(this.chkdata(split_data[6]))
                        // this._getSite(this.chkdata(split_data[16]))
                    }, 200);
                    break;
                }
        }
        this.setState({ showPopupOT3: !this.state.showPopupOT3 });
    }
    Get_PopUpcsvarinvbalpay = (data) => {
        this.CloseDialog(false)
        this.setdelete_no();
        var split_data = data.split("|");
        console.log("Get_PopUpcsvarinvbalpay", split_data);
        var element = true
        for (let index = 0; index < this.state.tableData.length; index++) {
            let arrData = this.state.tableData;
            if (arrData[index].T_Docdebt !== "" && arrData[index].T_Taxinvoice === split_data[1]) {
                // console.log(arrData[index].T_Taxinvoice ,"===", split_data[1]);
                element = false
            }
        }
        for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) { }
        if (i > this.state.rowtb - 1) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "รายการข้อมูลเกินกำหนด" })
            return;
        }
        if (element === true) {
            let arrData = this.state.tableData;
            var vc5 = split_data[8];
            var vc6 = split_data[9];
            arrData[i].T_Docdebt = this.chkdata(split_data[0]);
            arrData[i].T_Taxinvoice = this.chkdata(split_data[1]);
            arrData[i].T_Datedebt = this.chkdata(split_data[2]);
            arrData[i].T_Duedate = this.chkdata(split_data[4]);
            arrData[i].T_Residual = this.chkdata(parseFloat(vc5).toFixed(2));
            arrData[i].T_Payment = this.chkdata(parseFloat(vc6).toFixed(2));
            arrData[i].T_Overdue = this.chkdata(parseFloat(vc5 - vc6).toFixed(2));
            arrData[i].T_Remark = "";
            arrData[i].REFDOCTYPETEXT = this.chkdata(split_data[12]);
            arrData[i].T_Paybill = this.chkdata(split_data[11]);
            arrData[i].T_Category_Code = this.chkdata(split_data[13])
            arrData[i].SB = '1'

            this.setState({ tableData: arrData });
            this._calprice();
            this.bathprofit.current.value = "0.00"
            this.bathloss.current.value = "0.00"

        }
        // this.setState({ showPopUpcsvarinvbalpay: !this.state.showPopUpcsvarinvbalpay });

        // this.Department_code.current.value = ""
        // this.Department.current.value = ""
        // this.setState({ Department_txt: "" });
        // this.Branch_code.current.value = ""
        // this.Branch.current.value = ""
        // this.setState({ Branch_txt: "" });
    }
    PopUpOtherClose3 = () => {
        this.setState({ showPopupOT3: !this.state.showPopupOT3 });
    }

    SetPopup4 = (data) => {
        if (this.CustomerCode.current.value) {
            this.setState({ PopUpTYpe4: data });
            //ชื่อ
            this.setState({ typeFullScreenDialog: data })
            //open
            this.setState({ openFullScreenDialog: true })
            //title
            this.setState({ titleFullScreenDialog: "เลือกใบวางบิล-ARPaybill" })
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาใส่! รหัสลูกหนี้" })
        }
    }
    Get_PopUpOther4 = (data) => {
        this.CloseDialog(false)
        // this.setdelete_no();
        this.setdelete_no();
        var split_data = data.split("|");
        switch (this.state.PopUpTYpe4) {
            case "ARPaybill":
                var element = true
                for (let index = 0; index < this.state.tableData.length; index++) {
                    let arrData = this.state.tableData;
                    if (arrData[index].T_Docdebt !== "" && arrData[index].T_Taxinvoice === split_data[1]) {
                        // console.log(arrData[index].T_Taxinvoice ,"===", split_data[1]);
                        element = false
                    }
                }
                for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) { }
                if (element === true) {
                    // console.log(i, "===", this.state.tableData[i].T_Docdebt);
                    let arrData = this.state.tableData;
                    var vc5 = split_data[8];
                    var vc6 = split_data[8];
                    arrData[i].T_Docdebt = split_data[0];
                    arrData[i].T_Taxinvoice = split_data[1];
                    arrData[i].T_Datedebt = split_data[2];
                    arrData[i].T_Duedate = split_data[4];
                    arrData[i].T_Residual = parseFloat(vc5).toFixed(2);
                    arrData[i].T_Payment = parseFloat(vc6).toFixed(2);
                    arrData[i].T_Overdue = parseFloat(vc5 - vc6).toFixed(2);
                    arrData[i].T_Remark = split_data[9];
                    arrData[i].T_Category = split_data[10];
                    arrData[i].T_Category_Code = split_data[12];
                    arrData[i].T_Paybill = split_data[11];
                    arrData[i].SB = '1'
                    this.setState({ tableData: arrData });
                    this._calprice();
                    break;
                }
        }
        this.setState({ showPopupOT4: !this.state.showPopupOT4 });
    }
    PopUpOtherClose4 = (data) => {
        this.setState({ showPopupOT4: !this.state.showPopupOT4 });
    }
    //-------------------ลบแถว
    setdelete_load = () => {
        this.setState({ CSdelete: "" });
        this.setState({ CSdeletes: false });
        this.setState({ CSdelete_yes: false });
    }
    setdelete_no = () => {
        this.setState({ CSdelete: "far fa-trash-alt" });
        this.setState({ CSdeletes: false });
        this.setState({ CSdelete_yes: false });
    }
    setdelete_yes = () => {
        this.setState({ CSdelete: "fas fa-trash-alt" });
        this.setState({ CSdeletes: true });
        this.setState({ CSdelete_yes: true });
    }
    selectRowData = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.tableData[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0":
                if (this.state.tableData[rowIndex].T_Docdebt !== "") {
                    btnShow = < span >
                        < i className="" style={{ fontSize: '20px' }} onClick={this.Update_Status.bind(null, rowIndex, "1")} > {row.li} </i> </span>;
                } else {
                    btnShow = < span >
                        <  i className="" style={{ fontSize: '20px' }} > {row.li} </i> </span>;
                }
                break;
            case "1":
                btnShow = < span >
                    <i style={
                        { color: '#ff0000', marginTop: '3px' }}
                        className="far fa-minus-square"
                        onClick={this.Update_Status.bind(null, rowIndex, "0")} > </i> </span>;
                break;
            default:
                btnShow = < span > < i className="" > </i></span >;
        }
        return (<div> {btnShow} </div>)
    }
    deleterowall = () => {
        var btnShow = ""
        for (let i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].T_Docdebt !== "" && this.state.tableData[i].T_Docdebt !== undefined) {
                btnShow = <div id={"Icon_row"} style={{ cursor: "pointer", fontSize: "14px" }} align="center" onClick={this.confirm("", "0")}>
                    <i class="far fa-trash-alt" style={{ paddingTop: "7px" }}></i>
                </div>;
            }
        }
        return (<div>{btnShow}</div>);
    }
    Update_Status = (Row, Status) => {
        if (Status === 0) {
            var dataArray = this.state.tableData;
            dataArray[Row].T_Docdebt = "";
            this.setState({ tableData: dataArray });
            this.AddDataRow();
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) { }
            if (i <= 0) {
                this.setdelete_load();
            }
        } else {
            var dataArray = this.state.tableData;
            dataArray[Row].SB = Status;
            this.setState({ tableData: dataArray });
            var chk_all = 0;
            var chk_all_y = 0;
            for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].T_Docdebt; i++) {
                chk_all_y = chk_all_y + 1;
                if (this.state.tableData[i].SB === 1) {
                    chk_all = chk_all + 1;
                }
            }
            if (chk_all === chk_all_y && chk_all_y > 0) {
                this.setdelete_yes();
            }
        }
    }
    //--------------------------
    ReplaceThisPage = async (RowData) => {
        this.CloseDialog(false)
        this.setState({ Save_status: "disabled" });
        var url = "CSRECEIPT/GetCSRECEIPT?code=" + RowData.C2;
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                this.CustomerCode.current.value = res.data[0].ARCODE;
                this.CustomerName.current.value = res.data[0].ARNAME;
                this.DeliNumber.current.value = res.data[0].DOCNO;
                this.Remark.current.value = res.data[0].REMARK;
                this.Sumpayamount.current.value = res.data[0].SUMPAYAMOUNT/* .toFixed(2); */
                this.Depositpayment.current.value = res.data[0].DEPOSITPAYMENT/* .toFixed(2); */
                this.Discamount.current.value = res.data[0].DISCAMOUNT;
                this.Netpayamount.current.value = res.data[0].NETPAYAMOUNT/* .toFixed(2); */
                this.exchangerate.current.value = res.data[0].EXCHANGERATE/* .toFixed(2); */
                this.bathpayamount1.current.value = res.data[0].BATHPAYAMOUNT1
                this.bathpayamount2.current.value = res.data[0].BATHPAYAMOUNT2
                this.bathprofit.current.value = res.data[0].BATHPROFIT
                this.bathloss.current.value = res.data[0].BATHLOSS
                this.setState({ Docdate: ReDate(res.data[0].DOCDATE) })

                this.onAddValue("Groupdata", res.data[0].DOCGROUP, "");
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
            }
        }).catch(error => {
            console.log(error);
        });
        var url1 = "CSRECEIPT/GetCSRECEIPTSUB?code=" + RowData.C2;
        console.log(genURL(url1));
        axios.get(genURL(url1), { timeout: 3600 }).then(res => {
            var arrData = this.state.tableData;
            console.log(res.data.length);
            var j = 0;
            for (var i = 0; i < res.data.length; i++) {
                arrData[i] = {
                    li: i + 1,
                    C0: i,
                    T_Docdebt: res.data[i].REFDOCNO,
                    T_Taxinvoice: res.data[i].REFTAXNO,
                    T_Datedebt: this.GetformatTimestamp(res.data[i].REFDOCDATE),
                    T_Duedate: this.GetformatTimestamp(res.data[i].REFDUEDATE),
                    T_Residual: res.data[i].REFAMOUNT,
                    T_Payment: res.data[i].PAYAMOUNT,
                    T_Overdue: parseFloat(res.data[i].REFBALANCE).toFixed(2),
                    T_Remark: res.data[i].REMARK,
                    T_Category: this.REFDOCTYPE_TXT(res.data[i].REFDOCTYPE.toString()),
                    T_Category_Code: res.data[i].REFDOCTYPE.toString()
                }
            }
            console.log(arrData);
            this.setState({ tableData: arrData });
        }).catch(error => {
            console.log(error);
        });
    }


    ReplacePage = (e) => {
        this.setState({ openBackdrop: false })
        window.location.replace(e);

    };

    switchshowform = (e) => {
        this.setState({ showform: !this.state.showform });
    }
    _saveConnection = () => {
        if (this.state.tableData.length === 0) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกรายการ" })
            this.setState({ Uststus: false });
            return;
        } else if (this.CustomerCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.DOCGROUP_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.Department_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกแผนก" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.SiteCode_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกสาขา" })
            this.setState({ Uststus: false });
            return;
        } else {
            this.setState({ Uststus: true });
            this.state.PopUpSaveMoney = true;
        }
    }
    onSearch = () => {
        var data = this.state.tableData;
        for (var i = 0; i < data.length; i++) {
            data[i] = {
                li: i + 1,
                T_Docdebt: "",
                T_Taxinvoice: "",
                T_Datedebt: "",
                T_Duedate: "",
                T_Residual: "",
                T_Payment: "",
                T_Overdue: "",
                T_Remark: "",
                T_Category: "",
                T_Paybill: "",
                SELFLAG: "",
                SELFLAG2: "",
                usercode: "",
                project: "",
                allocatecode: "",
                sitecode: "",
                REFTAXAMOUNT: "",
                PAYTAXAMOUNT: "",
                INTEREST_RATE: "",
                PAYINTEREST: "",
                ARCODE: "",
                ARNAME: "",
                DOCGROUP: "",
                PAYBILLAMOUNT: "",
                PREPAYAMOUNT: "",
                FACTORING: "",
                REFAMOUNT: "",
                DEPARTNAME: "",
                BILLEXCHANGERATE: "",
                CURRENCYCODE: "",
                CURRNAME: "",
                TRANSREFDOCNO: "",
                REFINTEREST: ""
            }
        }
        this.setState({ tableData: data });
    }
    onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata":
                    await Checkdocgroup(value, "CSRECEIPT").then((result) => {
                        console.log("result", result);
                        if (result !== "") {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result
                            this.setState({ Groupdata_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.DeliNumber.current.value = ""
                        }
                    }).catch((err) => {
                        this.Groupdata_code.current.value = ""
                        this.Groupdata.current.value = ""
                        this.setState({ Groupdata_txt: "" });
                        this.DeliNumber.current.value = ""
                        console.log("catch Groupdata", err);
                    });

                    if (Fix !== "N") {
                        await Chackdocno(value, "CSRECEIPT").then((result1) => {
                            if (result1 !== "") {
                                this.DeliNumber.current.value = result1
                            } else {
                                this.DeliNumber.current.value = ""
                            }
                        }).catch((err) => {
                            this.DeliNumber.current.value = ""
                            console.log(err);
                        });
                    }


                    break;
                case "CustomerCode":
                    await ChackAr(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            this.CustomerCode.current.value = value
                            this.CustomerName.current.value = data[0]
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.CustomerCode.current.value = ""
                            this.CustomerName.current.value = ""
                        }
                    }).catch((err) => {
                        this.CustomerCode.current.value = ""
                        this.CustomerName.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Department":
                    await CheckDepartmentname(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            this.Department_code.current.value = value
                            this.Department.current.value = result
                            this.setState({ Department_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Department_code.current.value = ""
                            this.Department.current.value = ""
                            this.setState({ Department_txt: "" });
                        }
                    }).catch((err) => {
                        this.Department_code.current.value = ""
                        this.Department.current.value = ""
                        this.setState({ Department_txt: "" });
                        console.log(err);
                    });
                    break;
                case "Branch":
                    await CheckBrabchname(value).then((result) => {
                        if (result !== "") {
                            this.Branch_code.current.value = value
                            this.Branch.current.value = result
                            this.setState({ Branch_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Branch_code.current.value = ""
                            this.Branch.current.value = ""
                            this.setState({ Branch_txt: "" });
                        }
                    }).catch((err) => {
                        this.Branch_code.current.value = ""
                        this.Branch.current.value = ""
                        this.setState({ Branch_txt: "" });
                        console.log(err);
                    });
                    break;
                default: break;
            }
        } else {
            console.log("else value", value);
        }
    };
    confirm = (rowIndex, Name) => {
        if (Name === "1") {
            this.setState({ Namedelete: "คุณต้องการลบข้อมูลบรรทัดนี้ใช่หรือไม่ ? " })
            this.setState({ iddel: "1" })
        } else {
            this.setState({ Namedelete: "คุณต้องการลบข้อมูลทั้งหมดในตารางใช่หรือไม่ ? " })
            this.setState({ iddel: "0" })
        }
        this.setState({ ddd: rowIndex })
        this.setState({ show1: true })
    }
    expensesDelectROW = (row) => {
        var ROWDATA = this.state.tableData;
        ROWDATA[row] = {
            li: row + 1,
        }
        var j = 0;
        for (var i = 0; i < ROWDATA.length; i++) {
            if (ROWDATA[i].T_Docdebt) {
                ROWDATA[j] = ROWDATA[i];
                ROWDATA[j].li = j + 1;
                j++;
            }
        }
        for (var i = j; i < 10; i++) {
            ROWDATA[i] = { li: i + 1 }
        }
        this.setState({ tableData: ROWDATA });
    }
    expensesBTN(cell, row, enumObject, rowIndex) {
        var btnShow = ""
        if (row.SB === "1") {
            btnShow = <div id={"Icon_row" + row.li} style={{ cursor: "pointer", fontSize: "14px" }} align="center" onClick={this.confirm.bind(null, rowIndex, "1")}>
                <i class="far fa-trash-alt" style={{ paddingTop: "7px" }}></i>
            </div>;
        }
        return (<div>{btnShow}</div>);
    }
    selectok = (id) => {
        switch (id) {
            case "1":
                this.expensesDelectROW(this.state.ddd)
                break;
            case "0":
                this.setRow(this.state.rowtb)
                break;

            default:
                break;
        }

    }

    Chackdoc = () => {
        Chackdocno(this.Groupdata_code.current.value, "CSRECEIPT").then(async (result1) => {
            if (result1 !== undefined) {
                this.DeliNumber.current.value = await result1
            } else {
                this.DeliNumber.current.value = ""
            }
        }).catch((err) => {
            this.DeliNumber.current.value = ""
            console.log(err);
        });
    }
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialogs: e })
    }
    ReturnData = (e) => {
        console.log(e);
        if (e[1]) {
            this.setState({ setMultipletax: [...e[1]] })
        }
        if (e[2]) {
            this.setState({ Docdate1: e[2] })
        }
        if (e[3]) {
            this.setState({ Groupcode: e[3] })
        } else if (e[3] === "") {
            this.setState({ Groupcode: "" })
        }
        if (e[4]) {
            this.setState({ Groupname: e[4] })
        } else if (e[4] === "") {
            this.setState({ Groupname: "" })
        }
        if (e[5]) {
            this.setState({ Docno: e[5] })
        } else if (e[5] === "") {
            this.setState({ Docno: "" })
        }
        if (e[6]) {
            this.CustomerCode.current.value = e[6]
        }
        if (e[7]) {
            this.CustomerName.current.value = e[7]
        }
        if (e[8]) {
            this.setState({ Remark: e[8] })
        } else if (e[8] == "") {
            this.setState({ Remark: "" })
        }


    }
    openDialog = async () => {
        var Data = []
        Data = {
            from: "CSRECEIPT",
            userSite: this.state.siteCodeUser,
            defult: this.state.setMultipletax,
            Docdate: this.state.Docdate1,
            Groupdata_code: this.state.Groupcode,
            Groupdata: this.state.Groupname,
            DeliNumber: this.state.Docno,
            Code: this.CustomerCode.current.value,
            Name: this.CustomerName.current.value,
            Remark: this.state.Remark,
            TaxPersen: "7.00",
            Total: "0.00",
        }
        await this.setState({ dataMultipletax: Data })

        if (this.state.Docdate === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" })
            return
        }

        if (this.CustomerCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
            return
        }
        if (this.CustomerName.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
            return
        }
        await this.setState({ titleFullScreenDialogs: "เลือกใบกำกับภาษีหลายใบ" })
        await this.setState({ typeFullScreenDialog: "Inputmultipletax" })
        await this.setState({ openFullScreenDialogs: true })
    }
    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                case "Issuetype":
                    this.Issuetype.current.value = this.Issuetype_code.current.value
                    break;
                case "Department":
                    this.Department.current.value = this.Department_code.current.value
                    break;
                case "Branch":
                    this.Branch.current.value = this.Branch_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "CustomerCode") {
                this.onAddValue("CustomerCode", e.target.value);
            }
            if (e.target.name === "Issuetype") {
                this._chkData("Issuetype", e.target.value);
            }
            if (e.target.name === "Department") {
                this.onAddValue("Department", e.target.value);
            }
            if (e.target.name === "Branch") {
                this.onAddValue("Branch", e.target.value);
            }
        }
    };
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'CustomerCode':
                if (e.target.value === "") {
                    this.CustomerName.current.value = "";
                }
                break;
            case "Issuetype":
                if (this.Issuetype.current.value === "") {
                    this.setState({ Issuetype_txt: "" })
                    this.Issuetype_code.current.value = "";
                }
                break;
            case 'Department':
                if (e.target.value === "") {
                    this.setState({ Department_txt: "" })
                    this.state.Department_txt = ""
                }
                break;
            case 'Branch':
                if (e.target.value === "") {
                    this.setState({ Branch_txt: "" })
                    this.Branch_code.current.value = ""
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
        if (e.target.name === "Issuetype") {
            this.Issuetype.current.value = this.state.Issuetype_txt;
        }
        if (e.target.name === "Department") {
            this.Department.current.value = this.state.Department_txt;
        }
        if (e.target.name === "Branch") {
            this.Branch.current.value = this.state.Branch_txt;
        }
    }
    createCustomDeleteButton = (onClick) => {
        return (
            <button style={{ color: 'red' }} onClick={onClick}>ลบข้อมูลที่เลือก</button>
        )
    }
    onClickTopbar = async (e) => {
        console.log(e);
        switch (e) {
            case "save":
                // this._connectsaveData()
                await this.setState({ typeFullScreenDialog: "SaveMoney" })
                await this.setState({ titleFullScreenDialogs: "บันทึกรับเงิน" })
                await this.setState({ openFullScreenDialogs: true })
                break;

            case "new":
                // this.ResetThisPage("SAVE")
                this.ReplacePage(window.location.pathname + location.search)
                break;
            case "print":
                this._printReport(null)
                break;
            case "search":
                // this.setState({ SwitchSearchDoc: true });
                await this.setState({ typeFullScreenDialog: e })
                await this.setState({ titleFullScreenDialogs: "บันทึกรับชำระหนี้" })
                await this.setState({ openFullScreenDialogs: true })

                break;
            case "ARInvDebt":
                this.SetPopup3("ARInvDebt")
                break;
            case "csvarinvbalpay":
                this.SetPopUpcsvarinvbalpay(e)
                break;
            case "ARPaybill":
                this.SetPopup4("ARPaybill")
                break;
            case "Inputmultipletax":
                this.openDialog()
                break;
            case "Receiptwithholding":
                //ชื่อ
                this.setState({ typeFullScreenDialog: e })
                //open
                this.setState({ openFullScreenDialog: true })
                //title
                this.setState({ titleFullScreenDialog: "ภาษีหัก ณ ที่จ่าย" })
                break;
            default:
                break;
        }
    }
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }
    CloseDialogs = (e) => {
        this.setState({ openFullScreenDialogs: e })
    }

    _printReport = async (docno) => {
        try {
            if (formPrintdata.length > 1) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length })
                return;
            }
        } catch (error) {
        }
        if (this.state.reporturl !== "") {
            await this.setState({
                openReportFullScreenDialog: true,
                titleReportFullScreenDialog: "พิมพ์ใบรับชำระหนี้",
                urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`
            })
            return
        }
        else {
            this.ResetThisPage("SAVE")
            //  await this.ReplacePage(window.location.pathname + location.search)
        }
    }


    CloseReportDialog = async (e) => {
        await this.setState({ openReportFullScreenDialog: e })
        await this.ResetThisPage("SAVE")
        // this.ReplacePage(window.location.pathname + location.search)
    }


    withholding = (e) => {
        console.log("withholding", e);
        this.setState({
            withholdingData: e,
            openFullScreenDialog: false
        })
    }



    _reCHK = async (val) => {
        this.CloseDialogs(false)
        // console.log(val); 
        // this.onAddValue("Groupdata", "PR");
        // docno 
        this.setState({ Save_status: "disabled" });
        await axios.get(genURL(`CSRECEIPT/GetCSRECEIPT?code=${val[0].docNo}`)).then(res => {
            // await axios.get(genURLTEST(`/GetCSRECEIPT?code=${val[0].docno}`), { timeout: 3600 }).then(res => {
            console.log("_reCHK", res);
            if (res.data !== "") {
                this.setState({ resrecheckeddata: res.data })
                this.CustomerCode.current.value = res.data[0].ARCODE;
                this.CustomerName.current.value = res.data[0].ARNAME;
                this.DeliNumber.current.value = res.data[0].DOCNO;
                this.Remark.current.value = res.data[0].REMARK;
                this.Sumpayamount.current.value = res.data[0].SUMPAYAMOUNT;
                this.bathprofit.current.value = res.data[0].BATHPROFIT;
                this.bathloss.current.value = res.data[0].BATHLOSS;
                this.Discamount.current.value = res.data[0].DISCAMOUNT
                this.Netpayamount.current.value = res.data[0].CASHAMOUNT;
                this.state.AmountPayable = res.data[0].CASHAMOUNT
                this.Depositpayment.current.value = res.data[0].DEPOSITAMOUNT
                this.bathpayamount1.current.value = res.data[0].BATHPAYAMOUNT1
                this.bathpayamount2.current.value = res.data[0].BATHPAYAMOUNT2
                this.onAddValue("Groupdata", res.data[0].DOCGROUP, "N")
                this.onAddValue("Department", res.data[0].DEPARTMENT);
                this.onAddValue("Branch", res.data[0].SITECODE);
                this.setState({ Docdate_Recmoney: (res.data[0].Docdate_Recmoney == null) ? "" : ReDate(res.data[0].Docdate_Recmoney) })
                this.setState({ PROJECT: res.data[0].PROJECT })
            }
        }).catch(error => {
            console.log(error);
        });
        // var url = "CSARPAYBILL/Getbycodesub?code=" + val[0].docno;
        // console.log(genURL(url));
        await axios.get(genURL(`CSRECEIPT/GetCSRECEIPTSUB?code=${val[0].docNo}`)).then(res => {
            // await axios.get(genURLTEST(`/GetCSRECEIPTSUB?code=${val[0].docno}`), { timeout: 3600 }).then(res => {
            if (res.data !== "") {
                console.log("res.data", res.data);
                let arrData = this.state.tableData;
                for (var i = 0; i < res.data.length; i++) {
                    arrData[i].SB = "1"
                    arrData[i].T_Docdebt = res.data[i].REFDOCNO;
                    arrData[i].T_Taxinvoice = res.data[i].REFTAXNO;
                    arrData[i].T_Datedebt = this.GetformatTimestamp(res.data[i].REFDOCDATE);
                    arrData[i].T_Duedate = this.GetformatTimestamp(res.data[i].REFDUEDATE);
                    arrData[i].T_Residual = res.data[i].REFAMOUNT;
                    arrData[i].T_Payment = res.data[i].PAYAMOUNT;
                    arrData[i].T_Overdue = parseFloat(res.data[i].REFBALANCE).toFixed(2);
                    arrData[i].T_Remark = res.data[i].REMARK;
                    arrData[i].T_Category = this.REFDOCTYPE_TXT(res.data[i].REFDOCTYPE.toString())
                    arrData[i].T_Category_Code = res.data[i].REFDOCTYPE.toString()
                    arrData[i].CT_Category = res.data[i].REFDOCTYPE.toString()
                    //  arrData[i].T
                }
                this.setState({ tableData: arrData });
            }
        }).catch(error => {
            console.log(error);
        });
    }
    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            afterSaveCell: this.afterSaveCell
        }
        const options = {
            onRowClick: this.onRowClick,
            onMouseLeave: this.onMouseLeave,
        }
        const type = this.state.typeFullScreenDialog
        return (
            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur} >
                <FullScreenDialognew open={this.state.openReportFullScreenDialog} title={this.state.titleReportFullScreenDialog} CloseDialog={e => this.CloseReportDialog(e)}>
                    <Repostview url={this.state.urlsend} />
                </FullScreenDialognew>
                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialogs open={this.state.openFullScreenDialogs} title={this.state.titleFullScreenDialogs} closeDialog={e => this.CloseDialogs(e)}>
                    {this.state.typeFullScreenDialog === "SaveMoney" ? <PopUpSaveMoney closePopup={e => this.CloseDialogs(false)}
                        AmountPayable={this.state.AmountPayable}
                        from="CSRECEIPT"
                        get_PopUpSaveMoney={this._get_PopUpSaveMoney} pms="R|1|1|1|1|1|1"
                        //if  ยอดรวมเงิน-ยอดภาษี ณ ที่จ่าย 
                        withholdingdevalue={this.state.receivedwithholdingdevalue}
                        recheckeddata={this.state.resrecheckeddata}
                        depositpayment={this.Depositpayment.current.value}
                    /> : null}
                    {this.state.typeFullScreenDialog === "Inputmultipletax" ?
                        <PopUpMultipletax closePopup={e => this.CloseDialogs(false)}
                            parm={this.state.dataMultipletax}
                            resdata={e => this.ReturnData(e)}
                            recheckeddata={this.state.resrecheckeddata}
                            from="CSRECEIPT"
                        /> : null}

                    {this.state.typeFullScreenDialog === "search" ?
                        <Rechecked Dataselect={e => this._reCHK(e)} from="CSRECEIPT" /> : null}
                </FullScreenDialogs>
                <FullScreenDialog open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
                    {type === "Groupdata" || type === "Department" || type === "Branch" ? <PopUpOther closePopup={e => this.CloseDialog(e)} Get_PopUpOther={this.Get_PopUpOther} type={this.state.OtPopupType} Data={this.state.valuePopup} from="CSRECEIPT" userSite={this.state.siteCodeUser} /> : null}
                    {type === "Search_ARCode" ? <PopupArcode closePopup={e => this.CloseDialog(e)} Get_PopUparcode={this.Get_PopUparcode} /> : null}
                    {type === "ARInvDebt" ? <PopUpOther3 Get_PopUpOther3={this.Get_PopUpOther3} type={this.state.PopUpTYpe3} Data={this.state.valuePopup3} ARCODE={this.CustomerCode.current.value} from="CSRECEIPT" /> : null}
                    {type === "csvarinvbalpay" ? <PopUpcsvarinvbalpay Get_PopUpcsvarinvbalpay={this.Get_PopUpcsvarinvbalpay} ARCODE={this.CustomerCode.current.value} /> : null}
                    {type === "ARPaybill" ? <PopUpOther4 Get_PopUpOther4={this.Get_PopUpOther4} type={this.state.PopUpTYpe4} Data={this.state.valuePopup4} ARCODE={this.CustomerCode.current.value} from="CSRECEIPT" /> : null}
                    {type === "Receiptwithholding" ? <Receiptwithholding
                        userData={[this.CustomerCode.current.value.trim(), this.CustomerName.current.value.trim()]}
                        mainrowsData={this.state.tableData}
                        resdata={e => this.withholding(e)} withholdingdefaultValue={this.state.withholdingData}
                        receivedwithholdingdeData={e => this.setState({ receivedwithholdingdevalue: e })}
                    /> : null}
                </FullScreenDialog>
                {this.state.showform ? (<PopUpReport close={this.switchshowform} url={this.state.urlsend} />) : null}
                < Topbar
                    listmenu={listmenu}
                    title="บันทึกรับชำระหนี้"
                    onClick={e => this.onClickTopbar(e)}
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> รหัสลูกหนี้  </span>
                                                <input id="1" type="text" className="form-control " name="CustomerCode" ref={this.CustomerCode}
                                                // tabIndex={1} onKeyPress={this.Get_Arcode.bind(null)} onBlur={this.Get_Arcode.bind(null, "CustomerCode")} 
                                                />
                                                <span id="iconCustomerCode" className="input-group-addon icon" onClick={() => this.Switch_PopupArcode("Search_ARCode")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span id="iconCustomerName" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                                <input id="2" type="text" className="form-control " ref={this.CustomerName} name="CustomerName" onKeyDown={this.onKeyPressValue} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <MaterialUIPickers title="วันที่เอกสาร"
                                            DateValue={e => this.SelectSetData("Calendar1", e)}
                                            defaultdate={this.state.Docdate}
                                            open={this.state.checkenableInput['DOCDATE']}
                                        />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กลุ่มข้อมูล  </span>
                                                <input id="4"
                                                    type="hidden"
                                                    ref={this.Groupdata_code} />
                                                <input id="5" type="text" className="form-control " name="Groupdata" ref={this.Groupdata}
                                                // tabIndex={2} onKeyDown={this.onKeyPress} 
                                                />
                                                <span id="Docgroup" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Groupdata")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> เลขที่เอกสาร  </span>
                                                <input id="6" type="text" className="form-control " name="DeliNumber" ref={this.DeliNumber} readOnly={this.state.OpenTAXNO} />
                                                <span id="iconTaxNumber" className="input-group-addon icon">
                                                    <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="form-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                                <span className="input-group-addon"> สกุลเงิน  </span>
                                                <input id="7" type="text" className="form-control " name="Taxtype" ref={this.Currencycode} value="บาท" disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="form-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                                <span className="input-group-addon"> อัตราแลกเปลี่ยน  </span>
                                                <input id="8" type="text" className="form-control Price" name="exchangerate" ref={this.exchangerate} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                </div>
                <div >
                    <Modal show={this.state.show1} size="sm" /* onHide={true}  */ >
                        <ModalHeader style={{ borderRadius: '10px 10px 0px 0px' }}>
                            <div className="PopUpOtherDivH1"><i className="fas " style={{ color: 'black' }}> ลบข้อมูล </i></div>
                            <div className="PopUpOtherDivH2"><i className="fas fa-times" style={{ color: 'white' }} onClick={() => { this.setState({ show1: false }) }}></i></div>
                        </ModalHeader>
                        <ModalBody style={{ fontSize: '20px', left: '12px' }}> {this.state.Namedelete} </ModalBody>
                        <ModalFooter style={{ borderRadius: '0px 0px 10px 10px' }}>
                            <Button variant="secondary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={() => { this.selectok(this.state.iddel); this.setState({ show1: false }) }}> ใช่ </Button>
                            <Button variant="primary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={() => { this.setState({ show1: false }) }}> ไม่ใช่ </Button>
                        </ModalFooter>
                    </Modal>
                </div>
                <div className="container-fluid PSAppTable">
                    <BootstrapTable
                        //bordered={ false }
                        data={this.state.tableData}
                        cellEdit={cellEditProp}
                        options={options}
                        key={"1"}
                        trClassName='trClassName'
                        tableHeaderClass='trClassName'
                        height='400' hover
                    >
                        <TableHeaderColumn row='0' rowSpan={2} dataField='li' width="35" isKey editable={false}
                            dataAlign="center"> </TableHeaderColumn>

                        {/* ลบข้อมูลออกจากตาราง  */}
                        <TableHeaderColumn row='0' dataAlign="center" width="30">
                            <div onClick={this.deleterowall.bind(this)}> <i style={{ fontSize: '16px', marginTop: '5px', align: 'center' }}
                                className={this.state.CSdelete}> </i></div>
                        </TableHeaderColumn>
                        <TableHeaderColumn row='1' editable={false} dataField='SB' width="30" dataFormat={this.expensesBTN.bind(this)}></TableHeaderColumn>
                        {/* end ลบข้อมูลออกจากตาราง  */}
                        <TableHeaderColumn row='0' dataAlign="center" width="170"> เอกสารตั้งหนี้ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Docdebt' width="170" editable={false} dataAlign="left" ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="170"> ใบกำกับภาษี </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Taxinvoice' width="170" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"> วันที่ตั้งหนี้ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Datedebt' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"> ครบกำหนด </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Duedate' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="right" width="120"> มูลค่าคงเหลือ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Residual' width="120" dataAlign="right" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="right" width="120"> รับชำระ < i id="t_sitecode" style={{ fontSize: "10px" }} > </i></TableHeaderColumn >
                        <TableHeaderColumn row='1' dataField='T_Payment' width="120" editable={true} dataAlign="right" ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120" > คงค้าง </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataAlign="right" width="120" dataField='T_Overdue' editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120" > หมายเหตุ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Remark' width="120" ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"> ประเภท </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Category' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan={2} dataField='T_Category_Code'   >T_Category_Code</TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"  > ใบวางบิล </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Paybill' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' hidden={true} editable={false} dataField='C0' dataAlign="center"  > C0 </TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={8} md={8} lg={8}>
                            <Row className="show-grid">
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> แผนก  </span>
                                                <input type="hidden" ref={this.Department_code} />
                                                <input id="id1" type="text" className="form-control " name="Department" ref={this.Department}
                                                // tabIndex={4} onKeyDown={this.onKeyPress} 
                                                />
                                                <span id="CSDEPARTMENT" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Department")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <SelectDatas
                                                    origin="PROJECT"  // โครงการ
                                                    valueSelect={e => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                                                    title="โครงการ"
                                                    defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                                                />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> สาขา  </span>
                                                <input id="9" type="hidden" ref={this.Branch_code} />
                                                <input id="10" type="text" className="form-control " name="Branch" ref={this.Branch}
                                                // onKeyDown={this.onKeyPress} 
                                                />
                                                <span id="sitecode" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Branch")} >
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>

                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon "> ชำระอัตราตั้งหนี้(บาท)  </span>
                                                <input id="11" type="text" className="form-control Price" name="bathpayamount1" ref={this.bathpayamount1} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon "> ชำระอัตราปัจจุบัน(บาท)  </span>
                                                <input id="12" type="text" className="form-control Price" name="bathpayamount2" ref={this.bathpayamount2} disabled />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กำไรจากอัตรา  </span>
                                                <input id="13" type="text" className="form-control Price" ref={this.bathprofit} name="bathprofit" />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> ขาดทุนจากอัตรา  </span>
                                                <input id="14" type="text" className="form-control Price" ref={this.bathloss} name="bathloss" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หมายเหตุ  </span>
                                                <input id="15" type="text" className="form-control " name="Remark" ref={this.Remark} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={4} md={4} lg={4}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon "> รวมรับชำระ  </span>
                                                <input id="16" type="text" className="form-control Price" name="Sumpayamount" ref={this.Sumpayamount} disabled />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> ส่วนลด  </span>
                                                <input id="17" type="text" className="form-control Price" ref={this.Discamount} name="Discamount"
                                                    onClick={(e) => { if (e.target.value !== "") { e.target.value = parseFloat(e.target.value).toFixed(0); } }}
                                                    onKeyDown={this.Cal_Price1}
                                                    onBlur={this._calprice.bind(null)} />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หักเงินมัดจำ  </span>
                                                <input id="18" type="text" className="form-control Price" ref={this.Depositpayment} name="Depositpayment" value={this.state.Totalamount} disabled />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12' >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> ยอดเงินสุทธิ  </span>
                                                <input id="19" type="text" className="form-control Price" ref={this.Netpayamount} name="Netpayamount" value={this.state.Debtamount} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                    <Snackbar place="br"
                        color={this.state.color}
                        icon={this.state.icon}
                        autoClose={this.state.autoClose}
                        message={this.state.messagealert}
                        open={this.state.opensnackbar}
                        closeNotification={() => { this.setState({ opensnackbar: false }) }}
                        close />
                </div>
            </div >
        );
    }
}